import React from "react";
import { imageCodes, titleCodes, textCodes, videoCodes } from "../../template_codes/madnest/home_page_codes";
import { Link } from "react-router-dom";
import paths from "../../routes/paths";
import logo from "../../assets/images/madnest/mad_logo.jpg";

function Home() {
    return (
        <React.Fragment>
            <div className="font-quicksand ">
                <div class="navbar ">
                    <div class="navbar-start">

                    </div>
                    <div class="navbar-center lg:flex">
                        <ul class="menu menu-horizontal">
                            <li className="p-1"><Link to={paths.home}>Home</Link></li>
                            <li><a href="https://themadnest.com/">Shop</a></li>
                            <li className="p-1"><Link to={paths.about}>About Us</Link></li>
                            <li className="p-1"><Link to={paths.contact}>Contact</Link></li>
                        </ul>
                    </div>
                    <div className="navbar-end"></div>

                </div>

                {/*            homepage slider section              */}{/* 
                <div className="w-full pt-10 bg-mad_ban bg-no-repeat bg-cover">
                    <div className="pt-40 pb-40 text-center">
                        <h1 className="text-3xl pb-10 text-white">Madnest - your parents living nightmare</h1>
                        <button class="btn btn-outline btn-white text-white"><a href="https://themadnest.com">S h o p N o w </a></button>
                    </div>
                </div>*/}
                <div className=" hero w-full h-52 pb-10 lg:h-1/3 xl:h-1/3">
                    <img src={imageCodes.banner.image} className="py-1 w-full h-48 md:h-full lg:h-full xl:h-full" />
                    <div class="hero-content text-center text-neutral-content">
                        <div class="max-w-md">
                            <h1 className="text-md lg:text-2xl xl:text-2xl pt-10 lg:pt-40 xl:pt-40 text-white text-[#ffff00] py-4">Madnest - your parents living nightmare</h1>
                            <button className="btn btn-outline btn-white btn-xs lg:btn-sm xl:btn-md btn-outline text-[#ffff00]"><a href="https://themadnest.com"> S h o p N o w </a></button>
                        </div>
                    </div>
                </div>



                {/*            end of homepage slider section              */}

                {/*                      Categories Section                        */}
                <div className="pt-20 pb-10 px-10 md:px-14 lg:px-32 xl:px-44">
                    <h1 className="text-xl lg:text-2xl xl:text-2xl text-center pb-10 font-semibold">{titleCodes.title8.title}</h1>
                </div>
                <div class="container carousel carousel-center xl:carousel-center l:carousel-center p-4 space-x-10 w-screen">
                    <div class="carousel-item">
                        <a href="https://themadnest.com">
                            <img src={imageCodes.catego.image} className="rounded-full  w-40 h-40 place-items-center"></img>
                            <p className="text-md text-base md:pt-4 text-center">Cookie</p>
                        </a>
                    </div>
                    <div class="carousel-item">
                        <a href="https://themadnest.com">
                            <img src={imageCodes.catego1.image} className="rounded-full w-40 h-40 place-items-center"></img>
                            <p className="text-md text-base md:pt-4 text-center">Hoodie/Sweatshirt</p>
                        </a>
                    </div>
                    <div class="carousel-item">
                        <a href="https://themadnest.com">
                            <img src={imageCodes.catego2.image} className="rounded-full  w-40 h-40 place-items-center"></img>
                            <p className="text-md text-base md:pt-4 text-center">T-Shirt</p>
                        </a>
                    </div>
                    <div class="carousel-item">
                        <a href="https://themadnest.com">
                            <img src={imageCodes.catego3.image} className="rounded-full  w-40 h-40 place-items-center"></img>
                            <p className="text-md text-base md:pt-4 text-center">Umbrella</p>
                        </a>
                    </div>
                    <div class="carousel-item">
                        <a href="https://themadnest.com">
                            <img src={imageCodes.catego4.image} className="rounded-full w-40 h-40 place-items-center"></img>
                            <p className="text-md text-base md:pt-4 text-center">Pillow</p>
                        </a>
                    </div>
                    <div class="carousel-item">
                        <a href="https://themadnest.com">
                            <img src={imageCodes.catego5.image} className="rounded-full w-40 h-40 place-items-center"></img>
                            <p className="text-md text-base md:pt-4 text-center">Tote Bag</p>
                        </a>
                    </div>
                </div>

                {/*                    end of Categories Section                   */}

                {/*           slider section              */}
                <div className="pt-20 pb-10 px-10 md:px-14 lg:px-32 xl:px-44">
                    <h1 className="text-xl lg:text-2xl xl:text-2xl text-center pb-10 font-semibold">{titleCodes.title5.title}</h1>
                </div>
                <div className="carousel w-full h-52 pb-10 lg:h-1/3 xl:h-1/3">
                    <div id="slide1" className="carousel-item relative w-full">
                        <img src={imageCodes.slider.image} className="w-full" />
                        <div class="absolute flex justify-between transform -translate-y-1/2 left-5 right-5 top-1/2">
                            <a href="#slide3" className="btn btn-circle bg-maincolor bg-transperent w-10 h-40">❮</a>
                            <a href="#slide2" className="btn btn-circle bg-maincolor bg-transperent w-10 h-40">❯</a>
                        </div>
                    </div>
                    <div id="slide2" className="carousel-item relative w-full">
                        <img src={imageCodes.slider1.image} className="w-full" />
                        <div className="absolute flex justify-between transform -translate-y-1/2 left-5 right-5 top-1/2">
                            <a href="#slide1" className="btn btn-circle bg-maincolor bg-transperent w-10 h-40">❮</a>
                            <a href="#slide3" className="btn btn-circle bg-maincolor bg-transperent w-10 h-40">❯</a>
                        </div>
                    </div>
                    <div id="slide3" className="carousel-item relative w-full">
                        <img src={imageCodes.slider2.image} className="w-full" />
                        <div className="absolute flex justify-between transform -translate-y-1/2 left-5 right-5 top-1/2">
                            <a href="#slide2" className="btn btn-circle bg-maincolor bg-transperent w-10 h-40">❮</a>
                            <a href="#slide1" className="btn btn-circle bg-maincolor bg-transperent w-10 h-40">❯</a>
                        </div>
                    </div>
                </div>
                {/*            end of slider section           */}

                {/*                new arrivals section                */}
                <div className="w-fix">
                    <div className="pt-10 lg:pt-10 xl:pt-10">
                        <h1 className="text-xl lg:text-2xl xl:text-2xl font-semibold text-center pb-5">{titleCodes.title9.title}</h1>
                    </div>

                    <div className="container grid grid-cols-2 lg:grid-cols-4 xl:grid-cols-6 pt-10 px-4">
                        <div className="p-2 hover:-translate-y-1 duration-300 ...">
                            <div class="card w-40 md:w-40 l:w-48 xl:w-48 md:mb-8 shadow-xl hover:animate-pulse">
                                <a href="https://themadnest.com/product/cl0fclp88316901s69wiw5tck"><figure><img src={imageCodes.newArrival.image} alt="Date Set" /></figure></a>
                                <div class="card-body">
                                    <h5 class="card">
                                        I am ok
                                    </h5>
                                    <div class="card-actions justify-end">
                                        <div class="badge badge-outline">Fashion</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="p-2 hover:-translate-y-1 duration-300 ...">
                            <div class="card w-40 md:w-40 l:w-48 xl:w-48 md:mb-8 bg-base-100 shadow-xl hover:animate-pulse">
                                <a href="https://themadnest.com/product/cl48bai9l24022801s6tqc8xe0b"><figure><img src={imageCodes.newArrival1.image} alt="blazer" /></figure></a>
                                <div class="card-body">
                                    <h5 class="card">
                                        Aye Say Pal Original
                                    </h5>

                                </div>
                            </div>
                        </div>
                        <div className="p-2 hover:-translate-y-1 duration-300 ...">
                            <div class="card w-40 md:w-40 l:w-48 xl:w-48 md:mb-8 bg-base-100 shadow-xl hover:animate-pulse">
                                <a href="https://themadnest.com/product/cl0fc9ttv239801s6t0ghivpp"><figure><img src={imageCodes.newArrival2.image} alt="Tee" /></figure></a>
                                <div class="card-body">
                                    <h5 class="card">
                                        Madnest Grunge Texture
                                    </h5>

                                </div>
                            </div>
                        </div>
                        <div className="p-2 hover:-translate-y-1 duration-300 ...">
                            <div class="card w-40 md:w-40 l:w-48 xl:w-48 md:mb-8 bg-base-100 shadow-xl hover:animate-pulse">
                                <a href="https://themadnest.com/product/cl0fco838327801s64bwdrz8v"><figure><img src={imageCodes.newArrival3.image} alt="Tote Bag" /></figure></a>
                                <div class="card-body">
                                    <h5 class="card">
                                        Mad Umbrella
                                    </h5>

                                </div>
                            </div>
                        </div>
                        <div className="p-2 hover:-translate-y-1 duration-300 ...">
                            <div class="card w-40 md:w-40 l:w-48 xl:w-48 md:mb-8 bg-base-100 shadow-xl hover:animate-pulse">
                                <a href="https://themadnest.com/product/cl0fcpnhe338701s684xc112v"><figure><img src={imageCodes.newArrival4.image} alt="Tote Bag" /></figure></a>
                                <div class="card-body">
                                    <h5 class="card">
                                        Aye Say Pal(Limited Colour Edition)
                                    </h5>

                                </div>
                            </div>
                        </div>
                        <div className="p-2 hover:-translate-y-1 duration-300 ...">
                            <div class="card w-40 md:w-40 l:w-48 xl:w-48 md:mb-8 bg-base-100 shadow-xl hover:animate-pulse">
                                <a href="https://themadnest.com/product/cl0fcpnhe338701s684xc112v"><figure><img src={imageCodes.newArrival5.image} alt="Tote Bag" /></figure></a>
                                <div class="card-body">
                                    <h5 class="card">
                                        Madnest ( Classical Floral)
                                    </h5>

                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                {/*                  end of new arrivals section         */}


                {/*          shop now and youtube video section             */}
                <div className="container w-4/6  pb-20">
                    <h1 className="text-center font-semibold text-xl pb-10">{titleCodes.title3.title}</h1>
                    <iframe src={videoCodes.video1.video} title="YouTube video player" frameborder="0"
                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen
                        className="w-full h-96">
                    </iframe>
                </div>
                {/*          end of shop now and youtube video section       */}



                {/*                        ayesaypal collection section                        */}
                <div className="w-fix">
                    <div className="lg:pt-0 xl:pt-0">
                        <h1 className="text-xl lg:text-2xl xl:text-2xl font-semibold text-center pb-10">{titleCodes.title1.title}</h1>
                    </div>
                    <div className="container grid grid-cols-1 lg:grid-cols-3 xl:grid-cols-3 pb-20  lg:px-20 xl:px-20 px-4 place-items-center">
                        <div className="lg:pl-4 xl:pl-4 pb-10 focus-visible">
                            <a href="https://themadnest.com/product/cl4nxys5l6142001s6rvi8tpoe"><img src={imageCodes.ayesay.image}></img></a>
                            <a href="https://themadnest.com/product/cl4nxys5l6142001s6rvi8tpoe" className="pb-10"></a>
                        </div>
                        <div className="lg:pl-4 xl:pl-4 pb-10">
                            <a href="https://themadnest.com/product/cl0fczoay513701s63edcoduq"><img src={imageCodes.ayesay1.image}></img></a>
                            <a href="https://themadnest.com/product/cl0fczoay513701s63edcoduq" className="pb-10"></a>
                        </div>
                        <div className="lg:pl-4 xl:pl-4 pb-10 focus-visible">
                            <a href="https://themadnest.com/product/cl0fbe7t4171501s6d3cfafmg"><img src={imageCodes.ayesay2.image}></img></a>
                            <a href="https://themadnest.com/product/cl0fbe7t4171501s6d3cfafmg" className="pb-10"></a>
                        </div>
                    </div>
                </div>
                {/*                        end of ayesaypal collection section                  */}

                {/*          shop now and youtube video section             */}
                <div className="grid grid-cols-1 lg:grid-cols-2 xl:grid-cols-2 gap-20 pb-10 lg:pb-14">
                    <div className="mx-10">
                        <h1 className="text-xl lg:text-3xl xl:text-3xl lg:pt-20 xl:pt-20">{titleCodes.title4.title}</h1>
                        <p className="text-md lg:text-xl xl:text-xl lg:pt-10 xl:pt-10">{textCodes.text.text}</p>
                        <div className="pt-10 lg:pt-8">
                            <a class="btn btn-outline text-xl lowercasegit lowercase" href="https://themadnest.com">{textCodes.shopNow.text}</a>
                        </div>
                    </div>
                    <div>
                        <iframe src={videoCodes.video2.video}
                            title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; 
                            encrypted-media; gyroscope; picture-in-picture" allowfullscreen
                            className="w-96 pl-1 h-60 lg:w-5/6 lg:h-full xl:w-5/6 xl:h-screen xl:py-10 xl:pb-20"></iframe>
                    </div>
                </div>
                {/*          end of shop now and youtube video section             */}

                {/*                 best seller item section                */}
                <div className="w-fix">
                    <div className="pt-10 lg:pt-10 xl:pt-10">
                        <h1 className="text-xl lg:text-2xl xl:text-2xl font-semibold text-center pb-10">{titleCodes.title6.title}</h1>
                    </div>

                    <div className="container grid grid-cols-2 lg:grid-cols-3 xl:grid-cols-5 pb-14 place-items-center gap-1 lg:gap-0 xl:gap-0">
                        <div className="pb-10">
                            <div class="card w-78 md:w-64 md:mb-8 shadow-xl p-2 hover:animate-pulse">
                                <a href="https://themadnest.com/product/cl0fclp88316901s69wiw5tck"><figure><img src={imageCodes.product.image} alt="Date Set" /></figure></a>
                                <div class="card-body">
                                    <h5 class="card">
                                        Smoke Weed Everyday
                                    </h5>
                                    <div class="card-actions justify-end">
                                        <div class="badge badge-outline">Fashion</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className=" pb-10">
                            <div class="card w-78 md:w-64 md:mb-8 bg-base-100 p-2 shadow-xl hover:animate-pulse">
                                <a href="https://themadnest.com/product/cl4wu7xoa177401s63sz9nlgl"><figure><img src={imageCodes.product1.image} alt="blazer" /></figure></a>
                                <div class="card-body">
                                    <h5 class="card">
                                        Madnest Logo
                                    </h5>
                                    <div class="card-actions justify-end">
                                        <div class="badge badge-outline">Fashion</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className=" pb-10">
                            <div class="card w-78 md:w-64 md:mb-8 bg-base-100 p-2 shadow-xl hover:animate-pulse">
                                <a href="https://themadnest.com/product/cl0fc9ttv239801s6t0ghivpp"><figure><img src={imageCodes.product2.image} alt="Tee" /></figure></a>
                                <div class="card-body">
                                    <h5 class="card">
                                        Aye Say Pal(Limited)
                                    </h5>
                                    <div class="card-actions justify-end">
                                        <div class="badge badge-outline">Fashion</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className=" pb-10">
                            <div class="card w-78 md:w-64 md:mb-8 bg-base-100 p-2 shadow-xl hover:animate-pulse">
                                <a href="https://themadnest.com/product/cl0fco838327801s64bwdrz8v"><figure><img src={imageCodes.product4.image} alt="Tote Bag" /></figure></a>
                                <div class="card-body">
                                    <h5 class="card">
                                        Aye Say Pal
                                    </h5>
                                    <div class="card-actions justify-end">
                                        <div class="badge badge-outline">Fashion</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className=" pb-10">
                            <div class="card w-78 md:w-64 md:mb-8 bg-base-100 p-2 shadow-xl hover:animate-pulse">
                                <a href="https://themadnest.com/product/cl0fcpnhe338701s684xc112v"><figure><img src={imageCodes.product3.image} alt="Tote Bag" /></figure></a>
                                <div class="card-body">
                                    <h5 class="card">
                                        Mad Umbrella
                                    </h5>
                                    <div class="card-actions justify-end">
                                        <div class="badge badge-outline">Fashion</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                {/*                  end of best seller items section         */}



                {/*                        hoodie collection section                        */}
                <div className="w-fix">
                    <div className="lg:pt-0 xl:pt-0">
                        <h1 className="text-xl lg:text-2xl xl:text-2xl font-semibold text-center pb-10">{titleCodes.title7.title}</h1>
                    </div>
                    <div className="container grid grid-cols-1 lg:grid-cols-3 xl:grid-cols-3 pb-10  lg:px-20 xl:px-20 px-4">
                        <div className="lg:pl-4 xl:pl-4 shadow-xl pb-10 focus-visible">
                            <a href="https://themadnest.com/product/cl0fb0ygp085701s63i4atcwa"><img src={imageCodes.hoodie.image}></img></a>
                            <a href="https://themadnest.com/product/cl0fb0ygp085701s63i4atcwa" className="pt-20">Snake Ladder Game</a>
                        </div>
                        <div className="lg:pl-4 xl:pl-4 pb-10 shadow-xl">
                            <a href="https://themadnest.com/product/cl0f4nde3303501s6c96ml8oh"><img src={imageCodes.hoodie1.image}></img></a>
                            <a href="https://themadnest.com/product/cl0f4nde3303501s6c96ml8oh" className="pt-20">Till Death Do Us Apart</a>
                        </div>
                        <div className="lg:pl-4 xl:pl-4 pb-10 shadow-xl">
                            <a href="https://themadnest.com/product/cl0btz1791265601s6ior9o8tl"><img src={imageCodes.hoodie2.image}></img></a>
                            <a href="https://themadnest.com/product/cl0btz1791265601s6ior9o8tl" className="pt-20">Madnest Sweater</a>
                        </div>
                    </div>
                </div>
                {/*                        end of hoodie collection section                  */}

                {/*                 black tribe section                */}
                <div className="w-fix">
                    <div className="">
                        <h1 className="text-xl lg:text-2xl xl:text-2xl font-semibold text-center pb-5">{titleCodes.title2.title}</h1>
                    </div>

                    <div className="container grid grid-cols-2 lg:grid-cols-4 xl:grid-cols-6 pt-10 px-4">
                        <div className="p-2 hover:-translate-y-1 duration-300 ...">
                            <div class="card w-40 md:w-40 l:w-48 xl:w-48 md:mb-8 shadow-xl hover:animate-pulse">
                                <a href="https://themadnest.com/product/cl0fclp88316901s69wiw5tck"><figure><img src={imageCodes.items.image} alt="Date Set" /></figure></a>
                                <div class="card-body">
                                    <h5 class="card">
                                        Smoke Weed Everyday
                                    </h5>
                                    <div class="card-actions justify-end">
                                        <div class="badge badge-outline">Fashion</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="p-2 hover:-translate-y-1 duration-300 ...">
                            <div class="card w-40 md:w-40 l:w-48 xl:w-48 md:mb-8 bg-base-100 shadow-xl hover:animate-pulse">
                                <a href="https://themadnest.com/product/cl48bai9l24022801s6tqc8xe0b"><figure><img src={imageCodes.items1.image} alt="blazer" /></figure></a>
                                <div class="card-body">
                                    <h5 class="card">
                                        Universe's Dream
                                    </h5>
                                    <div class="card-actions justify-end">
                                        <div class="badge badge-outline">Fashion</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="p-2 hover:-translate-y-1 duration-300 ...">
                            <div class="card w-40 md:w-40 l:w-48 xl:w-48 md:mb-8 bg-base-100 shadow-xl hover:animate-pulse">
                                <a href="https://themadnest.com/product/cl0fc9ttv239801s6t0ghivpp"><figure><img src={imageCodes.items2.image} alt="Tee" /></figure></a>
                                <div class="card-body">
                                    <h5 class="card">
                                        Rage
                                    </h5>
                                    <div class="card-actions justify-end">
                                        <div class="badge badge-outline">Fashion</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="p-2 hover:-translate-y-1 duration-300 ...">
                            <div class="card w-40 md:w-40 l:w-48 xl:w-48 md:mb-8 bg-base-100 shadow-xl hover:animate-pulse">
                                <a href="https://themadnest.com/product/cl0fco838327801s64bwdrz8v"><figure><img src={imageCodes.items3.image} alt="Tote Bag" /></figure></a>
                                <div class="card-body">
                                    <h5 class="card">
                                        Puppet
                                    </h5>
                                    <div class="card-actions justify-end">
                                        <div class="badge badge-outline">Fashion</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="p-2 hover:-translate-y-1 duration-300 ...">
                            <div class="card w-40 md:w-40 l:w-48 xl:w-48 md:mb-8 bg-base-100 shadow-xl hover:animate-pulse">
                                <a href="https://themadnest.com/product/cl0fcpnhe338701s684xc112v"><figure><img src={imageCodes.items4.image} alt="Tote Bag" /></figure></a>
                                <div class="card-body">
                                    <h5 class="card">
                                        The Ritual
                                    </h5>
                                    <div class="card-actions justify-end">
                                        <div class="badge badge-outline">Fashion</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="p-2 hover:-translate-y-1 duration-300 ...">
                            <div class="card w-40 md:w-40 l:w-48 xl:w-48 md:mb-8 bg-base-100 shadow-xl hover:animate-pulse">
                                <a href="https://themadnest.com/product/cl0fcpnhe338701s684xc112v"><figure><img src={imageCodes.items5.image} alt="Tote Bag" /></figure></a>
                                <div class="card-body">
                                    <h5 class="card">
                                        Till Death Do Us Apart
                                    </h5>
                                    <div class="card-actions justify-end">
                                        <div class="badge badge-outline">Fashion</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                {/*                  end of black tribe section         */}
            </div>
        </React.Fragment>
    );
}

export default Home;